import {removeItem, setItem, getItem} from '@github-ui/safe-storage/session-storage'

/**
 * Gets the sessionStorage key for the active batch suggestions
 */
export function getActiveBatchStorageKey(pullRequestPath: string, headOid: string): string {
  return `${pullRequestPath}-${headOid}-active-batch-suggestions`
}

/**
 * Saves the active batch to sessionStorage
 */
export function saveActiveBatchToStorage(pullRequestPath: string, headOid: string, activeBatch: number[]): void {
  const key = getActiveBatchStorageKey(pullRequestPath, headOid)
  setItem(key, JSON.stringify(activeBatch))
}

/**
 * Loads the active batch from sessionStorage
 */
export function loadActiveBatchFromStorage(pullRequestPath: string, headOid: string): number[] {
  const key = getActiveBatchStorageKey(pullRequestPath, headOid)
  const stored = getItem(key)
  if (!stored) {
    return []
  }

  try {
    const parsed = JSON.parse(stored)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

/**
 * Clears the active batch from sessionStorage
 */
export function clearActiveBatchFromStorage(pullRequestPath: string, headOid: string): void {
  const key = getActiveBatchStorageKey(pullRequestPath, headOid)
  removeItem(key)
}
